/*
  nodeSubType - used only when nodeType = process
  supports 3 values : input, output, default 
  input - the first node, meaning there are no input nodes to it. 
  default - can have multiple inputs and single output
  output - the last node(eg, token issuer), there are no output nodes for it.  
*/
const jsonComponents = {
  signIn: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'signUp/ signIn Component',
    data: {
      contentDefinition: {
        displayName: 'Content Definition',
      },
      usernameType: {
        displayName: 'User Name Type',
        dataType: 'dropdown',
        values: ['email', 'shortNames', 'mixed'],
      },
      username: {
        displayName: 'Select User Name Attribute',
        dataType: 'dropdown',
        values: 'allClaims',
      },
      keepMeSignedIn: {
        displayName: 'Keep Me Signed In',
        dataType: 'dropdown',
        values: ['true', 'false'],
      },
      showPasswordTextbox: {
        displayName: 'Show Password Textbox',
        dataType: 'dropdown',
        values: ['true', 'false'],
      },
      links: {
        forgotPassword: {
          displayName: 'Forgot Password',
        },
        otp: {
          displayName: 'OTP',
        },
        createNewAccount: {
          displayName: 'Create New Account',
        },
        localAccountSignIn: {
          displayName: 'Local Account SignIn',
        },
        socialProviders: {
          google: { displayName: 'Google', enabled: true },
          employeeLogin: { displayName: 'Employee Login (premium plan)', enabled: false },
          facebook: { displayName: 'Facebook (premium plan)', enabled: false },
          discord: { displayName: 'Discord (premium plan)', enabled: false },
          linkedIn: { displayName: 'LinkedIn (premium plan)', enabled: false },
          weChat: { displayName: 'Wechat (premium plan)', enabled: false },
        },
      },
      nodeLinks: {
        displayName: 'Add a Component',
      },
      sessionManagement: true,
      sessionTypes: 'default',
    },
  },

  google: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'Google',
    data: {
      partnerClaimTypes: ['id', 'email', 'given_name', 'family_name', 'name'],
      sessionManagement: true,
      sessionTypes: 'default',
    },
  },

  aadCreate: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'AAD Create',
    data: {
      transformation: {
        'string concatenation': {
          claim: '',
          claim2: '',
        },
      },
      indexProperty: {
        displayName: 'Unique id for creation',
        dataType: 'dropdown',
        values: ['email', 'short username', 'foreign objectid'],
        dataTypes: ['string', 'string', 'userIdentity'],
      },
      error: {
        displayName: 'Throw an error if the user principal being read does not exist',
        values: false,
      },
      mapObjectId: {
        displayName: 'Map created Object Id',
      },
      mapUserPrincipalName: {
        displayName: 'Map created user principal name',
      },
      sessionManagement: true,
      sessionTypes: 'default',
    },
  },
  aadUpdate: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'AAD Update',
    data: {
      transformation: {
        'string concatenation': {
          claim: '',
          claim2: '',
        },
      },
      indexProperty: {
        displayName: 'Index to find the object',
        dataType: 'dropdown',
        values: ['objectid', 'short username', 'email', 'foreign objectid' /*'extension attribute'*/],
        dataTypes: ['string', 'string', 'string', 'userIdentity' /*'string'*/],
      },
      error: {
        displayName: 'Throw an error if the user principal being read does not exist',
        values: false,
      },
      mapObjectId: {
        displayName: 'Map return Object Id',
      },
      sessionManagement: true,
      sessionTypes: 'default',
    },
  },
  aadRead: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'AAD Read',
    data: {
      indexProperty: {
        displayName: 'Index to find the object',
        dataType: 'dropdown',
        values: ['objectid', 'short username', 'email', 'foreign objectid' /*'extension attribute'*/],
        dataTypes: ['string', 'string', 'string', 'userIdentity' /*'string'*/],
      },
      throwErrorIfNotFound: {
        displayName: 'Throw an error if the user principal being read does not exist',
        values: false,
      },
      sessionManagement: true,
      sessionTypes: 'default',
    },
  },

  restAPI: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'REST API',
    data: {
      sessionManagement: true,
      sessionTypes: 'default',
    },
  },
  usernamePasswordValidation: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'Username Password Validation',
    data: {
      claim: {
        displayName: 'Claims',
        dataType: 'dropdown',
        values: 'allClaims',
      },
      errorMsg: 'Username password is invalid. Please re-enter your credentials.',
      usernameType: {
        displayName: 'User Name Type',
        dataType: 'dropdown',
        values: ['email', 'shortNames', 'mixed'],
      },
      username: {
        displayName: 'Select User Name Attribute',
        dataType: 'dropdown',
        values: 'allClaims',
      },
      password: 'password',
      sessionManagement: false,
      sessionTypes: 'none',
    },
  },
  conditionals: {
    nodeType: 'decision',
    nodeSubType: 'default',
    label: 'Conditional',
    data: {
      operator: {
        boolean: ['==', '!='],
        string: ['==', '!=', 'contains'],
        dateTime: ['==', '<=', '>=', 'exists', 'does not exist'],
      },
      compareTo: {
        boolean: ['literal', 'claim'],
        string: ['literal', 'claim', 'sessionContext'],
        dateTime: ['claim', 'sessionContext'],
      },
      sessionManagement: false,
    },
  },

  appInsights: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'App Insights',
  },

  userInputPage: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'User Input Page',
    contentDefinition: {
      displayName: 'Content Definition',
    },
    sessionManagement: true,
    sessionTypes: 'default',
    passwordOptions: [
      'Lowercase Letters (a to z)',
      'Uppercase Letters (A to Z)',
      'Number (0-9)',
      'Special character($./!)',
      'length',
    ],
    minConstraints: 4,
    passwordLength: [2, 50],
  },

  errorPage: {
    nodeType: 'process',
    nodeSubType: 'output',
    label: 'Error Page',
    contentDefinition: {
      displayName: 'Content Definition',
    },
    sessionManagement: false,
  },

  authorizeToken: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'Token Authorization',
    sessionManagement: false,
  },

  tokenIssuer: {
    nodeType: 'process',
    nodeSubType: 'output',
    label: 'Token Issuer',
    sessionManagement: false,
  },

  userInfoIssuer: {
    nodeType: 'process',
    nodeSubType: 'output',
    label: 'User Info Issuer',
    sessionManagement: false,
  },

  mfa: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'MFA Authentication',
    contentDefinition: {
      displayName: 'Content Definition',
    },
    mode: {
      alwaysNew: 'Always Manual Entry',
      newIfNotPresent: 'Manual Entry if Number Empty',
      existingOnly: 'No Manual Entry',
    },
    phoneNumberClaim: '',
    idClaim: '',
    enteredPhoneNumberClaim: '',
    newNumberFlagClaim: '',
    sessionManagement: true,
    sessionTypes: 'default',
  },

  validateMagicLink: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'Validate Magic Link',
    sessionManagement: true,
    sessionTypes: 'default',
  },

  webAuthnRegistration: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'WebAuthn Registration',
    data: {
      apiUrl: '',
      idClaim: '',
      nameClaim: '',
      displayNameClaim: '',
      successClaim: '',
      sessionManagement: true,
      sessionTypes: 'default',
      contentDefinition: { displayName: 'Content Definition URL' },
    },
  },

  webAuthnAuthentication: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'WebAuthn Authentication',
    data: {
      apiUrl: '',
      idClaim: '',
      successClaim: '',
      sessionManagement: true,
      sessionTypes: 'default',
      contentDefinition: { displayName: 'Content Definition URL' },
    },
  },

  webAuthnAvailability: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'WebAuthn Availability',
    data: {
      availabilityClaim: '',
      sessionManagement: true,
      sessionTypes: 'default',
      contentDefinition: { displayName: 'Content Definition URL' },
    },
  },

  webAuthnCredentialsExist: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'WebAuthn Credentials Exist',
    data: {
      existsClaim: '',
      sessionManagement: true,
      sessionTypes: 'default',
      contentDefinition: { displayName: 'Content Definition URL' },
    },
  },

  conditionalAccessEvaluation: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'Conditional Access Evaluation',
    data: {
      idClaim: '',
      mfaRegisteredClaim: '',
      changePasswordChallenge: '',
      mfaChallenge: '',
      blockChallenge: '',
      sessionManagement: true,
      sessionTypes: 'default',
    },
  },

  conditionalAccessRemediation: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'Conditional Access Remediation',
    data: {
      sessionManagement: true,
      sessionTypes: 'default',
    },
  },

  sendEmailOTP: {
    nodeType: 'process',
    nodeSubType: 'output',
    label: 'Send Email OTP',
    data: {
      sessionManagement: false,
    },
  },

  sessionExists: {
    nodeType: 'decision',
    nodeSubType: 'default',
    label: 'SSO Session Exists',
  },

  oidcIdP: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'OIDC IdP Authentication',
    data: {
      sessionManagement: true,
      sessionTypes: 'default'
    }
  },

  samlIdP: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'SAML IdP Authentication',
    data: {
      sessionManagement: true,
      sessionTypes: 'default'
    }
  },

  validationError: {
    nodeType: 'process',
    nodeSubType: 'output',
    label: 'Validation Error'
  },

  setClaims: {
    nodeType: 'process',
    nodeSubType: 'default',
    label: 'Set Claims',
    data: {
      sessionManagement: true,
      sessionTypes: 'default'
    }
  }
};

export function addComponent(name: string, cmp: any) {
  //@ts-ignore
  jsonComponents[name] = cmp;
}

export default jsonComponents;
